import React, { useState } from 'react';
import { Link, useMatch } from 'react-router-dom';
import { URLS } from 'Douleutaras/constants/urls';
import { useTranslation } from 'react-i18next';
import Dropdown from 'Douleutaras/components/Dropdown/Dropdown';
import DropdownItem from 'Douleutaras/components/Dropdown/DropdownItem';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { selectIsCreditUser } from 'Douleutaras/redux/data/auth/authSlice';
import { CreditButton } from 'Douleutaras/layout/partials/CreditButton/CreditButton';
import { getAbsoluteUrl } from 'Douleutaras/utilities/url-builder';
import { useSubscriptionTier } from 'Douleutaras/hooks/users/proSubscriptionTier';
import classNames from 'classnames';

import './DefaultHeaderProMenu.scss';

const DefaultHeaderProMenu = () => {
  const { t } = useTranslation();
  const [jobsDropdown, setJobsDropdown] = useState(false);
  const isCreditUser = useAppSelector(selectIsCreditUser);
  const ff = useAppSelector(state => state.featureFlags.entities);

  const { isGoldOrSilverTier, currentSubscriptionTier } = useSubscriptionTier();

  const openJobsCallback = dropDownStatus => { setJobsDropdown(dropDownStatus); };
  const menuItems = [
    { text: t('My jobs'), url: URLS.SELLER.MY_JOBS, dataTracking: 'pro-dashboard-navbar__assigned-jobs', isReactRoute: true },
    { text: t('Concluded'), url: URLS.SELLER.CONCLUDED, dataTracking: 'pro-dashboard-navbar__completed-jobs', isReactRoute: true }
  ];

  const menuItemsProV2 = [
    { text: t('T.PRO-HEADER.MY JOBS'), url: URLS.SELLER.MY_JOBS, dataTracking: 'pro-dashboard-navbar__assigned-jobs',
      isActive: Boolean(useMatch(URLS.SELLER.MY_JOBS)), isReactRoute: true
    },
    { text: t('T.PRO-HEADER.CONCLUDED JOBS'), url: URLS.SELLER.CONCLUDED_v2, dataTracking: 'pro-dashboard-navbar__completed-jobs',
      isActive: Boolean(useMatch(URLS.SELLER.CONCLUDED_v2)), isReactRoute: true
    },
    { text: t('T.PRO-HEADER.CANCELLED JOBS'), url: URLS.SELLER.CANCELLED, dataTracking: 'pro-dashboard-navbar__cancelled-jobs',
      isActive: Boolean(useMatch(URLS.SELLER.CANCELLED)), isReactRoute: true
    }
  ];

  if (isGoldOrSilverTier) {
    menuItems.push({
      text: t('Proposals'),
      url: `${URLS.SELLER.PROPOSED}?tier=${currentSubscriptionTier}`,
      dataTracking: 'pro-dashboard-navbar__available-jobs',
      isReactRoute: false
    });
    menuItemsProV2.push(
      {
        text: t('Proposals'),
        url: `${URLS.SELLER.PROPOSED}?tier=${currentSubscriptionTier}`,
        dataTracking: 'pro-dashboard-navbar__available-jobs',
        isReactRoute: false,
        isActive: false
      }
    );
  }

  const activeMenuItemPro = menuItemsProV2.find(menuItem => menuItem.isActive);

  return (
      <div styleName="default-header-pro-menu">
        <div styleName="default-header-pro">
          <Dropdown
            direction="left"
            isOpen={jobsDropdown}
            showHeader
            header={
              <div styleName="default-header-pro-item">
                <button styleName={classNames(
                  'default-header-pro-item__link',
                  'default-header-pro-item__button',
                  { active: jobsDropdown,
                    'active-page': Boolean(useMatch({ path: 'dashboard-v2/pro/bids', end: false }))})}
                >
                  <i styleName="default-header-pro-item__icon" className="dashicon dashicon-tools" />
                  <span styleName="default-header-pro-item__title">{activeMenuItemPro ? activeMenuItemPro.text : t('JOBS')}</span>
                </button>
              </div>
            }
            callback={openJobsCallback}
          >
            { isCreditUser
            ? menuItems.map((item, i) => (
                <DropdownItem
                  key={i}
                  text={item.text}
                  href={item.url}
                  dataTracking={item.dataTracking}
                  isReactRoute={item.isReactRoute}
                  onClick={() => setJobsDropdown(false)}
                />
              ))
            : menuItemsProV2.map((item, i) => (
              <DropdownItem
                active={item.isActive}
                key={i}
                text={item.text}
                href={item.url}
                dataTracking={item.dataTracking}
                isReactRoute={item.isReactRoute}
                onClick={() => setJobsDropdown(false)}
              />
            ))}
          </Dropdown>
        </div>

        <div styleName="default-header-pro default-header-pro--hide-mobile">
          <div styleName="default-header-pro-item">
            <Link to={getAbsoluteUrl(ff.proScoreEnabled ? 'PRO_DASHBOARD.STATS_CENTER.SCORE' : 'PRO_DASHBOARD.STATS_CENTER.INDEX')}
                  styleName={classNames(
                    'default-header-pro-item__link',
                    { active: Boolean(useMatch({ path: `/dashboard-v2/pro/${URLS.PRO_DASHBOARD.STATS_CENTER.INDEX}`, end: false })) })}
                  data-tracking="pro-dashboard-navbar__stats"
            >
              <span styleName="default-header-pro-item__title">{t('STATS')}</span>
            </Link>
          </div>
        </div>

        <CreditButton />
      </div>
  );
};

export default DefaultHeaderProMenu;
